import { motion } from "framer-motion";
import { Landmark, CreditCard, Building2, ArrowRight } from "lucide-react";
import { scrollToId } from "./scroll";
import { useI18n } from "../../i18n";

const meta = [
  { icon: Landmark, num: "01", span: "lg:col-span-7" },
  { icon: CreditCard, num: "02", span: "lg:col-span-5" },
  { icon: Building2, num: "03", span: "lg:col-span-12" },
];

export const Services = () => {
  const { t } = useI18n();
  return (
    <section id="services" className="py-24 lg:py-36" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="font-heading text-gold text-sm tracking-[0.25em] uppercase mb-6">{t("services.kicker")}</p>
          <h2 className="font-heading font-bold tracking-tighter text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
            {t("services.heading")}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {t("services.items").map((s, i) => {
            const m = meta[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.12 }}
                className={`service-card p-8 lg:p-12 ${m.span}`}
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between mb-10">
                  <m.icon size={36} className="text-gold" strokeWidth={1.4} />
                  <span className="font-heading outline-text text-4xl font-bold">{m.num}</span>
                </div>
                <h3 className="font-heading font-bold tracking-tight text-2xl lg:text-3xl mb-4">{s.title}</h3>
                <p className="text-[#8A9DB1] leading-relaxed max-w-2xl text-base md:text-lg">{s.desc}</p>
                <button
                  onClick={() => scrollToId("contact")}
                  className="inline-flex items-center gap-2 mt-8 text-gold font-heading text-sm tracking-[0.12em] uppercase group"
                  data-testid={`service-cta-${i}`}
                >
                  {t("services.discuss")}
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                </button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
